import script from "./File.vue?vue&type=script&setup=true&lang=ts"
export * from "./File.vue?vue&type=script&setup=true&lang=ts"

import "./File.vue?vue&type=style&index=0&id=4b94caa8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b94caa8"]])

export default __exports__